import { useQuery } from '@tanstack/react-query'
import { fetchPartyWithDetails, partyKeys } from '@/services/parties'

export function usePartyWithDetails(id: string | undefined) {
  const partyQuery = useQuery({
    queryKey: partyKeys.detailWithData(id!),
    queryFn: () => fetchPartyWithDetails(id!),
    enabled: !!id,
  })

  return {
    party: partyQuery.data,
    isLoading: partyQuery.isLoading,
    error: partyQuery.error,
  }
}
